const ENDPOINT = "/api/v1/page_pulse/collect";

export function trackPagePulse(event, options = {}) {
  const payload = buildPayload(event, options);
  if (!payload) {
    return;
  }

  if (options.beacon && navigator.sendBeacon) {
    const body = new Blob([JSON.stringify(payload)], { type: "application/json" });
    if (navigator.sendBeacon(ENDPOINT, body)) {
      return;
    }
  }

  fetch(ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken(),
    },
    credentials: "same-origin",
    keepalive: Boolean(options.keepalive || options.beacon),
    body: JSON.stringify(payload),
  }).catch(() => {});
}

export function trackPagePulseBatch(events, options = {}) {
  const payloadEvents = events
    .map((event) => buildPayload(event.event, event))
    .filter(Boolean);

  if (payloadEvents.length === 0) {
    return;
  }

  trackPagePulse(null, { ...options, payload: { events: payloadEvents } });
}

function buildPayload(event, options) {
  if (options.payload) {
    return options.payload;
  }

  if (!event) {
    return null;
  }

  const payload = {
    event,
    url: normalizePath(options.url || window.location.pathname),
  };

  if (options.subjectType) {
    payload.subject_type = options.subjectType;
  }

  if (options.subjectId) {
    payload.subject_id = options.subjectId;
  }

  return payload;
}

function normalizePath(value) {
  const pathname = new URL(value, window.location.origin).pathname;
  return pathname.replace(/^\/[a-z]{2}(?=\/)/, "") || "/";
}

function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content || "";
}
